import { Length } from "./Length";
import LengthValue from "./LengthValue";
import { LengthValueMillimeter } from "./LengthValueMillimeter";

export class LengthMaths {

    public static getLengthValue(length: Length | undefined | null) : LengthValue {
        if (length instanceof LengthValue) {
            return length as LengthValue; 
        } else {
            return new LengthValueMillimeter(0); 
        }
    }

    static multiply(a: LengthValue, b: number): LengthValue {
        return new LengthValueMillimeter(a.millimeter * b);
    }

    static divide(a: LengthValue, b: number): LengthValue {
        return new LengthValueMillimeter(a.millimeter / b);
    }

    static divideInt(a: LengthValue, b: number): LengthValue {

        if (b === 0) {
            throw new Error("Le diviseur ne peut pas être zéro.");
        }
        let value = Math.floor(a.millimeter / b);

        return new LengthValueMillimeter(value);
    }

    static add(a: LengthValue, b: LengthValue): LengthValue {
        return new LengthValueMillimeter(a.millimeter + b.millimeter);
    }

    static subtract(a: LengthValue, b: LengthValue): LengthValue {
        return new LengthValueMillimeter(a.millimeter - b.millimeter);
    }

    static lessThan(a: LengthValue, b: LengthValue): boolean {
        return a.millimeter < b.millimeter;
    }

    static greaterThan(a: LengthValue, b: LengthValue): boolean {
        return a.millimeter > b.millimeter;
    }

    static lessThanOrEqual(a: LengthValue, b: LengthValue): boolean {
        return a.millimeter <= b.millimeter;
    }

    static greaterThanOrEqual(a: LengthValue, b: LengthValue): boolean {
        return a.millimeter >= b.millimeter;
    }

    static get Zero(): LengthValue {
        return new LengthValueMillimeter(0);
    }
}